import { nsAccount } from '@/app/i18n/namespaces';
import MERCHANT_ACCOUNT_STATUS from '../enums/merchantAccountStatus';


export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    ORGANIZATION_UUID: {
        key: 'provider'
    },
    EMAIL: {
        key: 'email',
        entity: 'keys.email',
        type: 'email',
        namespace: nsAccount,
        placeholder: 'filter.placeholder.email',
        filter: 'input',
        enableSorting: true
    },
    STATUS: {
        key: 'status',
        type: 'badge',
        entity: 'keys.status',
        namespace: nsAccount,
        prefix: 'account_status_',
        enum: MERCHANT_ACCOUNT_STATUS,
        filter: 'select',
        enableSorting: true
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        namespace: nsAccount,
        entity: 'keys.created_at',
        enableSorting: true,
        filter: 'date'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        namespace: nsAccount,
        entity: 'keys.updated_at',
        enableSorting: true,
        filter: 'date'
    },
    LABEL: {
        key: 'label',
        type: 'string',
        entity: 'keys.label',
        namespace: nsAccount,
        placeholder: 'filter.placeholder.label',
        filter: 'input',
        enableSorting: true
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    PROVIDER: {
        key: 'provider'
    },
    X25_CENTERS: {
        key: 'x25Centers'
    }
};